import { Component, Input } from '@angular/core';

/** Handset status line: network name on the left, signal and battery on the right. */
@Component({
  selector: 'app-status-bar',
  standalone: true,
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.css',
})
export class StatusBarComponent {
  @Input() carrierName: string = 'Test network';
  /** Kept for older callers; the bar now follows the console theme. */
  @Input() dark: boolean = false;
}
